import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChartEmptyState = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 288,
	height: 156,
	viewBox: "0 0 288 156",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 288,
			height: 156
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 119.5,
			x2: 272,
			y2: 119.5,
			stroke: "#A8B1BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242 18C242 16.8954 242.895 16 244 16H262C263.105 16 264 16.8954 264 18V119H242V18Z",
			fill: "#CDD3DD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M198 37C198 35.8954 198.895 35 200 35H218C219.105 35 220 35.8954 220 37V119H198V37Z",
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154 54C154 52.8954 154.895 52 156 52H174C175.105 52 176 52.8954 176 54V119H154V54Z",
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110 77C110 75.8954 110.895 75 112 75H130C131.105 75 132 75.8954 132 77V119H110V77Z",
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66 61C66 59.8954 66.8954 59 68 59H86C87.1046 59 88 59.8954 88 61V119H66V61Z",
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 72C22 70.8954 22.8954 70 24 70H42C43.1046 70 44 70.8954 44 72V119H22V72Z",
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23,
			y: 130,
			width: 20,
			height: 6,
			rx: 3,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 67,
			y: 130,
			width: 20,
			height: 6,
			rx: 3,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 111,
			y: 130,
			width: 20,
			height: 6,
			rx: 3,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 155,
			y: 130,
			width: 20,
			height: 6,
			rx: 3,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 199,
			y: 130,
			width: 20,
			height: 6,
			rx: 3,
			fill: "#E4E8EE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 243,
			y: 130,
			width: 20,
			height: 6,
			rx: 3,
			fill: "#CDD3DD"
		})
	]
});
const ForwardRef = forwardRef(SvgBarChartEmptyState);
export { ForwardRef as ReactComponent };
